export default {
  banner: {
    image: "/img/FordLogo.png",
    title: "Ford x Lasso",
  },
  languageSwitcher: {
    title: "Switch language",
    cta: "Switch language",
  },
  rulesAndRegs: "Official Contest Rules",
  close: "Close",
  wait: "Please wait...",
  email: "Email",
  yes: "Yes",
  no: "No",
  submit: "Register",
  reset: "Reset",
  form: {
    title: "Registration",
    subittle: "Fill in the form to enter the contest",
    rules: "Rules & Regulations",
  },
  success: {
    title: "Thank you!",
    message: "Your registration was submitted successfully.",
  },
  notFound: {
    title: "Page not found",
    message: "The page you are looking for does not exist.",
    goHome: "Go to home",
  },
  resetTimer: "Reset {seconds}",
  footer: {
    title: "Official Contest Rules",
    credits: "© Ford Canada. All rights reserved.",
  },
  error: "Something went wrong...",
  clearCache: "Clear browser cache",
};
